import styled from 'styled-components';
 
const Container = styled.div`
    max-width: 120rem;
    min-height:100vh;
    margin: 0 auto;
    display:flex;
    flex-direction:column;
    align-items:center;
    position:relative;
`
 
export default Container;